import BaseRepository from './base-repository'
import CrudRepository from './crud-repository'
import UtilsRepository from './utils-repository'

export default {
  base: BaseRepository,
  crud: CrudRepository,
  utils: UtilsRepository,
}
